import type { Contacts } from "@/src/gql/graphql";

// ============================================================================
// CONTACT DETAIL TEMPLATES CONFIGURATION
// ============================================================================

export const contactTitleTemplate = (contact: Contacts) => contact.name;

export const contactDescriptionTemplate = (contact: Contacts) => {
  const parts = [];

  // Add title/position if available
  if (contact.title) {
    parts.push(contact.title);
  }

  // Add company name if available
  if (contact.company_name) {
    parts.push(contact.company_name);
  }

  return parts.length > 0 ? parts.join(" • ") : contact.name;
};
